// extracted by mini-css-extract-plugin
export default {"reportReadPageHeroBlock":"ReportReadPageHeroBlock_reportReadPageHeroBlock__PwqTq","button":"ReportReadPageHeroBlock_button__qYua-","text":"ReportReadPageHeroBlock_text__Z4i1a"};